import { RefObject } from 'react';
import { TravelPackage } from '../../types/TravelPackage';
import { Client } from '../../types/Quotation';
import { QuotationRoomOccupancy } from '../QuotationBuilder/quotationRoomOccupancy';

export type BuilderMode = 'package' | 'quotation';

export type HighlightLimits = {
  min: number;
  max: number;
  maxChars: number;
};

export type DescriptionLimits = {
  min: number;
  max: number;
};

export type FaqLimits = {
  questionMax: number;
  answerMaxWords: number;
};

export type PriceOverrideKey = 'flights' | 'hotels' | 'transfers' | 'visa' | 'insurance' | 'activities' | 'addons';

export type PriceOverrides = Record<PriceOverrideKey, number | null>;

export type BreakdownCategoryTotals = Record<PriceOverrideKey, number>;

export const emptyBreakdownCategoryTotals: BreakdownCategoryTotals = {
  flights: 0,
  hotels: 0,
  transfers: 0,
  visa: 0,
  insurance: 0,
  activities: 0,
  addons: 0,
};

export type PackageBuilderLocationState = {
  mode?: BuilderMode;
  packageToCopy?: TravelPackage;
  packageToEdit?: TravelPackage;
  packageFromDraft?: unknown;
  queryId?: number;
  hotelRooms?: QuotationRoomOccupancy[];
  showTemplatePicker?: boolean;
  quotationStep?: 'builder' | 'review';
};

export function isPackageBuilderLocationState(value: unknown): value is PackageBuilderLocationState {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  return true;
}

export type BookingDraftRecord = {
  id: number | string;
  query_id?: number;
  queryId?: number;
  updated_at?: string;
  created_at?: string;
};

export type BookingDraftCreateInput = {
  productType: 'package';
  provider: 'CRM';
  title: string;
  currency: 'INR' | 'USD';
  amountPaise: number;
  startAt?: string | null;
  endAt?: string | null;
  providerRef: Record<string, unknown>;
  queryId: number;
  customerId?: number;
  assignedId?: number;
  createdBy?: number;
};

export type ShareQuotationInput = {
  nightsCount: number;
  queryId?: number;
  startDate: string;
  hotelRooms: QuotationRoomOccupancy[];
  totalPrice: number;
  providerRef: Record<string, unknown>;
  pdfRef: RefObject<HTMLDivElement | null>;
  currency: 'INR' | 'USD';
  title: string;
  customerId?: number;
  assignedId?: number;
  createdBy?: number;
  download?: boolean;
  client?: Client;
  shareDraft?: boolean;
};
